import quickfireModel from "quickfire/model/quickfire-model";
import BetModel from "slotworks/model/bets/bet-model";
import Gameplay from "slotworks/model/gameplay/gameplay";
import SpinRequestPayload from "slotworks/model/gameplay/requests/spin-request-payload";
import { RequestBuilder } from "slotworks/server/builders/request-builder";

class SpinRequestBuilder implements RequestBuilder {

    public filter(request: any): boolean {
        return request instanceof SpinRequestPayload;
    }

    public build(gameplay: Gameplay, request: any) {

        if (quickfireModel.playingFreeGames) {
            return this.buildFreeGamesRequest();
        } else {
            return this.buildSpinRequest();
        }

    }

    private buildSpinRequest() {
        const chipSize = BetModel.getCreditSize();
        const numChips = BetModel.getCreditPerLine();
        const activePaylines = BetModel.getSelectedLineIds().map((value) => value - 1).join(",");

        const packet = `<Request verbex="Spin" chipSize="${chipSize}" numChips="${numChips}" activePaylines="${activePaylines}" />`;

        return packet;
    }

    private buildFreeGamesRequest() {
        const freeGame = quickfireModel.freeGames[0];
        const chipSize = freeGame.chipSize;
        const numChips = freeGame.numChips;
        const activePaylines = freeGame.activePaylines.join(",");
        const offerId = freeGame.offerId;
        const instanceId = freeGame.instanceId;

        const packet = `<Request verbex="Spin" chipSize="${chipSize}" numChips="${numChips}" activePaylines="${activePaylines}" offerId="${offerId}" instanceId="${instanceId}" />`;

        return packet;
    }
}

export default new SpinRequestBuilder();
